import {CalendarIcon, HamburgerIcon, InfoIcon, UnlockIcon, ViewIcon,CheckIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Link as ChakraLink,
  CloseButton,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  Image,
  ListItem,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Select,
  Text,
  UnorderedList,
  useDisclosure,
} from "@chakra-ui/react";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { BaseUrl } from "../../const.ts";
import { TicketContext, useContext } from "../../context/index.tsx";
import { useUserDetails } from "../../hooks/useUserDetails.ts";
import { i18nInstance } from "../../i18n.ts";
import ForgetPassword from "../login/forgetPassword/index.tsx";
import { SignIn } from "../login/signIn/index.tsx";
import SignUp from "../login/signUp/index.tsx";

const Header = () => {
  const { checkLogin, setCheckLogin } = useContext(TicketContext);
  const {
    isOpen: signUpIsOpen,
    onOpen: signUpOnOpen,
    onClose: signUpOnClose,
  } = useDisclosure();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [token, setToken] = useState(false);
  const [forgot, setForgot] = useState<boolean>(false);
  const [selectedLang, setSelectedLang] = useState(i18nInstance.language || 'az');


  const { data } = useUserDetails(Cookies.get("userId"));
  const profileImage = data?.body?.userView?.profilePhoto || ""; // Add a fallback if profilePhoto is undefined
  const userName = data?.body?.userView?.userName
    ? data.body.userView.userName.slice(0, 2)
    : ""; // Fallback for userName

  // Fetch user details
  // const { data } = useUserDetails(Cookies.get("userId"));
  // const profileImage = data?.body.userView?.profilePhoto;
  // const userName = data?.body.userView?.userName.slice(0, 2);
  useEffect(() => {
    setSelectedLang(i18nInstance.language);
  }, [i18nInstance.language]);
  // Language change handler
  const changeLanguage = (lang: string) => {
    document.documentElement.setAttribute("lang", lang);
    i18nInstance.changeLanguage(lang);
    setSelectedLang(lang);
  };

  // Log out parts
  const logoutHandler = () => {
    if (Cookies.get("access")) {
      Cookies.remove("access");
      navigate(0);
    } else {
      console.log("Access cookie not found");
    }
  };

  useEffect(() => {
    const accessToken = Cookies.get("access");
    if (accessToken) {
      setToken(!token);
    }
  }, []);

  // Hamburger
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Control modal behavior based on screen size

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      padding={{ base: "25px 0", xl: "25px 10vw" }}
      bgColor="#fff"
      w="100%"
      margin={"auto"}
      position="fixed"
      zIndex={"2"}
      boxShadow="0 4px 12px rgba(0, 0, 0, 0.1)"
    >
      <Link to="/">
        <Image
          src="../assests/logo.png"
          alt="Logo"
          w="200px"
          cursor="pointer"
        />
      </Link>

      <UnorderedList
        display={{ base: "none", lg: "flex" }}
        listStyleType="none"
        gap={{ base: "20px", xl: "50px" }}
        fontWeight="500"
        fontSize={{ base: "14px", lg: "18px" }}
      >
        {["discover", "About", "Contact"].map((item, index) => (
          <ListItem
            key={index}
            _hover={{
              color: "#342ab5",
              transition: "color 0.3s",
              textDecoration: "underline",
            }}
            cursor="pointer"
          >
            <Link to={`/${item.toLowerCase()}`}>{t(item)}</Link>
          </ListItem>
        ))}
      </UnorderedList>

      <Box
        display={{ base: "none", lg: "flex" }}
        alignItems="center"
        gap="10px"
      >
        <ChakraLink
          href="https://play.google.com/store/apps/details?id=com.eventeam.android"
          isExternal
        >
          <Image
            src="https://eventeam.az/static/media/playstore.png?v1"
            alt="Google Play Badge"
            w={{ base: "80px", md: "120px" }}
            _hover={{ transform: "scale(1.05)" }}
            transition="all 0.2s"
          />
        </ChakraLink>
        <ChakraLink
          href="https://apps.apple.com/us/app/eventeam/id1625176323"
          isExternal
        >
          <Image
            src="https://eventeam.az/static/media/appstore.png?v1"
            alt="App Store Badge"
            w={{ base: "80px", md: "120px" }}
            _hover={{ transform: "scale(1.05)" }}
            transition="all 0.2s"
          />
        </ChakraLink>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        gap={{ base: "10px", md: "20px" }}
      >
        {/* Language Select */}
        <Select
          display={{ base: "none", lg: "flex" }}
          width="100px"
          bg="transparent"
          p="8px"
          borderRadius="100px"
          cursor="pointer"
          border="1px solid black"
          fontWeight="600"
          onChange={(e) => changeLanguage(e.target.value)}
          color="#090632" // Main brand color
          _focus={{ borderColor: "#66F5FF", outline: "none" }} // Adjust focus border color
        >
          <option value="en" style={{ color: "black" }}>
            EN
          </option>
          <option selected value="az" style={{ color: "black" }}>
            AZ
          </option>
          <option value="ru" style={{ color: "black" }}>
            RU
          </option>
        </Select>

        {/* Sign In Button */}
        {!token && (
          <>
            <Button
              color="white"
              borderRadius="99px"
              colorScheme="cyan"
              onClick={() => setCheckLogin(!checkLogin)}
            >
              {t("Sign in")}
            </Button>
            <Modal isOpen={checkLogin} onClose={() => setCheckLogin(false)}>
              <ModalOverlay />
              <ModalContent>
                <ModalCloseButton />
                <ModalBody p="0">
                  <Box w="100%" mx="auto">
                    {forgot ? (
                      <ForgetPassword setForgot={setForgot} />
                    ) : (
                      <SignIn setForgot={setForgot} />
                    )}
                  </Box>
                </ModalBody>
              </ModalContent>
            </Modal>
            <Button
              color="white"
              borderRadius="99px"
              colorScheme="brand"
              bg="#111833"
              onClick={signUpOnOpen}
            >
              {t("Signup")}
            </Button>
            <Modal isOpen={signUpIsOpen} onClose={signUpOnClose}>
              <ModalOverlay />
              <ModalContent>
                <ModalCloseButton />
                <ModalBody p={0}>
                  <Box w="100%" mx="auto">
                    <SignUp onClose={signUpOnClose} />
                  </Box>
                </ModalBody>
              </ModalContent>
            </Modal>
          </>
        )}

        {/* User Menu */}
        {token && (
          <Menu>
            <MenuButton
              as={IconButton}
              borderRadius="full"
              aria-label="Options"
              icon={
                profileImage ? (
                  <Image
                    borderRadius="full"
                    boxSize="45px"
                    src={`${BaseUrl}/images/${profileImage}`}
                    alt="Profile Image"
                    border="2px solid #6AF6FF" // Border with brand color
                  />
                ) : (
                  <Text
                    pt="10px"
                    bg="#6AF6FF"
                    color="white"
                    borderRadius="full"
                    w="45px"
                    h="45px"
                    textAlign="center"
                  >
                    {userName}
                  </Text>
                )
              }
              variant="outline"
              borderColor="#6AF6FF" // Border with brand color
              _hover={{ bg: "#f0f0f0" }} // Light background on hover
            />

            <MenuList>
              <MenuOptionGroup title={t("Profile")} type="radio">
                <Link to="/account">
                  <MenuItemOption _hover={{ bg: "#f0f0f0" }}>
                    <InfoIcon mr={2} color="#111833" />
                    {t("Your profile")}
                  </MenuItemOption>
                </Link>
                <Link to="/tickets">
                  <MenuItemOption _hover={{ bg: "#f0f0f0" }}>
                    <ViewIcon mr={2} color="#111833" />
                    {t("see_all_tickets")}
                  </MenuItemOption>
                </Link>
                <Link to="/hosted">
                  <MenuItemOption _hover={{ bg: "#f0f0f0" }}>
                    <CalendarIcon mr={2} color="#111833" />
                    {t("see_all_hosted_events")}
                  </MenuItemOption>
                </Link>
                <Link to="/business-verification">
                  <MenuItemOption _hover={{ bg: "#f0f0f0" }}>
                    <CheckIcon  mr={2} color="#111833" />
                    {t("business_verification")}
                  </MenuItemOption>
                </Link>
                <MenuDivider />
                <MenuItemOption
                    onClick={logoutHandler}
                    _hover={{ bg: "#f0f0f0" }}
                    color="red.500"
                >
                  <UnlockIcon mr={2} color="red.500" />
                  {t("Log out")}
                </MenuItemOption>
              </MenuOptionGroup>
            </MenuList>

          </Menu>
        )}

        {/* Hamburger Menu */}
        <Box display={{ base: "flex", lg: "none" }}>
          <HamburgerIcon fontSize={"25px"} onClick={onOpen} color="#6AF6FF" />
          <Drawer onClose={onClose} isOpen={isOpen} placement="left">
            <DrawerOverlay />
            <DrawerContent>
              <DrawerHeader display={"flex"} justifyContent={"space-between"}>
                <Flex
                  w="100%"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Text color="#6AF6FF">{t("Menu")}</Text>
                  <Select
                      value={selectedLang}
                      display={{ base: "none", lg: "flex" }}
                      width="100px"
                      bg="transparent"
                      p="8px"
                      borderRadius="100px"
                      cursor="pointer"
                      border="1px solid black"
                      fontWeight="600"
                      onChange={(e) => changeLanguage(e.target.value)}
                      color="#090632"
                      _focus={{ borderColor: "#66F5FF", outline: "none" }}
                  >
                    <option value="en" style={{ color: "black" }}>EN</option>
                    <option value="az" style={{ color: "black" }}>AZ</option>
                    <option value="ru" style={{ color: "black" }}>RU</option>
                  </Select>
                </Flex>

                <CloseButton onClick={onClose} />
              </DrawerHeader>
              <DrawerBody>
                <ChakraLink
                  href="https://play.google.com/store/apps/details?id=com.eventeam.android"
                  isExternal
                >
                  <Image
                    src="https://eventeam.az/static/media/playstore.png?v1"
                    alt="Google Play Badge"
                    mb="10px"
                    w={{ base: "80px", md: "120px" }}
                    _hover={{ transform: "scale(1.05)" }}
                    transition="all 0.2s"
                  />
                </ChakraLink>
                <ChakraLink
                  href="https://apps.apple.com/us/app/eventeam/id1625176323"
                  isExternal
                >
                  <Image
                    src="https://eventeam.az/static/media/appstore.png?v1"
                    alt="App Store Badge"
                    w={{ base: "80px", md: "120px" }}
                    mb="10px"
                    _hover={{ transform: "scale(1.05)" }}
                    transition="all 0.2s"
                  />
                </ChakraLink>
                {["About", "Contact", "Events"].map((item, index) => (
                  <Link
                    key={index}
                    to={`/${item.toLowerCase()}`}
                    onClick={onClose}
                    style={{
                      marginBottom: "10px",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#6AF6FF", // Brand color for text
                      display: "block",
                    }}
                  >
                    {t(item)}
                  </Link>
                ))}
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
